import React from "react";
import keya from "../../assets/images/keya.webp";
import bigm from "../../assets/images/bigm.webp";
import blurise from "../../assets/images/blurise.webp";
import { MdChevronRight } from "react-icons/md";

const products = [
  {
    img: blurise,
    title: "Hệ thống quản lý giáo dục Blue Rise",
    description:
      "Nền tảng quản lý trung tâm giáo dục toàn diện, nâng cao trải nghiệm khách hàng",
    link: "produ",
  },
  {
    img: bigm,
    title: "Học viện Bigmax Academy",
    description:
      "Đào tạo kỹ năng và nâng cao kiến thức cho thế hệ trẻ với các khóa học chuyên sâu.",
    link: "produ",
  },
  {
    img: keya,
    title: "Dầu bơ ép lạnh - KeyAvo",
    description:
      "Sản phẩm dầu bơ nguyên chất, giàu dinh dưỡng, hỗ trợ sức khỏe toàn diện.",
    link: "produ",
  },
];

export default function Project() {
  return (
    <div className="w-full container mx-auto p-3 mt-9 flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <p className="text-[1.125rem] font-semibold text-[#033F6A]">
          Các sản phẩm chính của
        </p>
        <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
          <p className="text-[1.125rem] font-semibold text-white">BlueSkyIT</p>
        </div>
      </div>
      <div>
        <p className="text-[1.5rem] text-[#1375B7] font-semibold lg:text-[2.25rem]">
          Những sản phẩm chính của chúng tôi
        </p>
        <p className="text-[1rem] font-normal text-[#333] lg:w-[66rem]">
          Mỗi sản phẩm của chúng tôi đều hướng tới việc mang lại giá trị thực
          tiễn và hỗ trợ sự phát triển bền vững cho khách hàng.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-4 lg:grid-cols-3 w-full">
        {products.map(({ img, title, description, link }) => (
          <div
            key={title}
            className="shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]"
          >
            <div>
              <img
                src={img}
                alt={title}
                className="w-full h-auto rounded-t-[20px]"
              />
            </div>
            <div className="flex flex-col gap-3 bg-white border border-[#E2E2E2] rounded-b-[20px] px-[30px] py-[16px] relative h-[220px] lg:h-[190px]">
              <p className="text-[24px] font-semibold text-[#0C5393] md:h-20 overflow-scroll overflow-x-hidden">
                {title}
              </p>
              <p className="text-[16px] font-normal text-[#333333] md:h-20 overflow-scroll overflow-x-hidden">
                {description}
              </p>
              <a href={link}>
                <div className="flex items-center gap-2 text-[#919191] text-[16px] font-normal hover:text-gray-700 absolute bottom-2">
                  <p>Xem thêm</p>
                  <MdChevronRight />
                </div>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
